import type { IncomingMessage } from 'http';

import { getSharedBranchCookieDomain } from '@/utils/domains';
import { getCurrentEnv } from '@/utils/getCurrentEnv';
import { getHostnameFromForwardedAndHost } from '@/utils/server/lob-utils';

export function getRequestHostname(req: Pick<IncomingMessage, 'headers'>): string {
    return getHostnameFromForwardedAndHost(req) ?? '';
}

/**
 * Optional `domain` for platypus feature-instance hosts (e.g. `.shared.branch.paramountplus.com`)
 * so cookies set with this scope (`CBS_COM`, `CBS_RR`/`CBS_ST`, dev region/locale, etc.) are visible
 * across `web-mf-*` subdomains. Use the same value when **deleting** those cookies. Omits `domain`
 * for non-platypus envs and non-FI hostnames.
 */
export function getSharedBranchAuthCookieDomain(
    req: Pick<IncomingMessage, 'headers'>,
): string | undefined {
    if (getCurrentEnv() !== 'platypus') {
        return undefined;
    }
    const hostname = getRequestHostname(req);
    const domain = getSharedBranchCookieDomain(hostname);
    return domain || undefined;
}
